import { SEARCH_ENDPOINT, SEARCH_PARAM } from "../../constants/ApiConstants";

import Error from "../../helpers/Error";
import axios from "axios";

export default async function getSearchResultsCall(s?: string) {
    let params: any = {};
    if (s) {
        params[SEARCH_PARAM] = s;
    }
    try {
        const response = await axios.get(SEARCH_ENDPOINT, { params });
        return response.data ? Object.values(response.data) : [];
    } catch (error: any) {
        throw new Error(error.response.data.message, error.response.data.code);
    }
}
